import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * When set to `true` on a request's HttpContext, the global
 * HttpErrorInterceptor will NOT show an error toast for that request.
 *
 * Use it when a caller (effect/component) handles the failure itself and shows
 * its own contextual toast, to avoid the double-toast problem (findings B3):
 *
 *   this.http.post(url, body, { context: skipErrorToast() })
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/** Convenience helper to build an HttpContext that opts out of the global toast. */
export function skipErrorToast(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_ERROR_TOAST, true);
}
